export var QueryChangePart;
(function (QueryChangePart) {
    QueryChangePart[QueryChangePart["Conditions"] = 1] = "Conditions";
    QueryChangePart[QueryChangePart["Columns"] = 2] = "Columns";
    QueryChangePart[QueryChangePart["SortingColumns"] = 4] = "SortingColumns";
    QueryChangePart[QueryChangePart["Properties"] = 32] = "Properties";
    QueryChangePart[QueryChangePart["ExtraData"] = 64] = "ExtraData";
    QueryChangePart[QueryChangePart["Facets"] = 128] = "Facets";
    QueryChangePart[QueryChangePart["Aggregation"] = 256] = "Aggregation";
    QueryChangePart[QueryChangePart["All"] = 511] = "All";
})(QueryChangePart || (QueryChangePart = {}));
export var QueryChangeAction;
(function (QueryChangeAction) {
    QueryChangeAction[QueryChangeAction["Add"] = 1] = "Add";
    QueryChangeAction[QueryChangeAction["Modify"] = 2] = "Modify";
    QueryChangeAction[QueryChangeAction["Delete"] = 4] = "Delete";
    QueryChangeAction[QueryChangeAction["Activate"] = 8] = "Activate";
    QueryChangeAction[QueryChangeAction["All"] = 127] = "All";
})(QueryChangeAction || (QueryChangeAction = {}));
//# sourceMappingURL=query_events.js.map